import { render, staticRenderFns } from "./Visit.vue?vue&type=template&id=2bb04419&scoped=true&"
import script from "./Visit.vue?vue&type=script&lang=js&"
export * from "./Visit.vue?vue&type=script&lang=js&"
import style0 from "./Visit.vue?vue&type=style&index=0&id=2bb04419&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb04419",
  null
  
)

export default component.exports